import type { LanguagePack } from './types'

export const hi: LanguagePack = {
  navSaved: 'सेव किए',
  navInfo: 'जानकारी',
  homeTitle: 'अपने कागज़ की फोटो खींचिए',
  homeHint: 'समझो बताएगा कि कागज़ में क्या लिखा है और आपको आगे क्या करना है।',
  takePhoto: 'फोटो खींचो',
  uploadFile: 'फोटो या PDF डालो',
  supportedFiles: 'फोटो (JPG, PNG, WEBP) या PDF · 10 MB तक',
  chooseLanguage: 'किस भाषा में समझें',
  privacyLine: 'आपका कागज़ इसी फ़ोन पर पढ़ा जाता है। जब तक आप "सेव करें" न दबाएँ, कुछ भी सेव नहीं होता।',

  previewTitle: 'क्या फोटो ठीक है?',
  rotate: 'घुमाओ',
  crop: 'काटो',
  cropDone: 'हो गया',
  retake: 'दोबारा खींचो',
  readNow: 'पढ़ो',
  docLanguageLabel: 'कागज़ किस भाषा में लिखा है?',
  docLanguageHint: 'अंग्रेज़ी हमेशा साथ में पढ़ी जाती है।',

  stepCheck: 'फोटो जाँची जा रही है…',
  stepRead: 'कागज़ पढ़ा जा रहा है…',
  stepExtract: 'ज़रूरी जानकारी निकाली जा रही है…',
  stepExplain: 'हिंदी में समझाया जा रहा है…',
  firstTimeNote: 'पहली बार थोड़ा ज़्यादा समय लगेगा, क्योंकि पढ़ने का टूल डाउनलोड हो रहा है।',
  cancel: 'रोकें',

  errBadImage: 'फोटो थोड़ी साफ़ नहीं है। कृपया एक और साफ़ फोटो खींचिए।',
  errNoText: 'समझो को कागज़ पर लिखा हुआ कुछ नहीं मिला।',
  errUnclearPart: 'इस हिस्से को समझो ठीक से पढ़ नहीं पाया।',
  errUnsupportedLanguage: 'इस भाषा को अभी सपोर्ट नहीं करते।',
  errLongDocument: 'यह कागज़ काफ़ी लंबा है। पहले ज़रूरी पेज चुनें।',
  errFileType: 'कृपया फोटो (JPG, PNG, WEBP) या PDF चुनें।',
  errFileSize: 'यह फ़ाइल 10 MB से बड़ी है। कृपया छोटी फ़ाइल चुनें।',
  errGeneric: 'कुछ गड़बड़ हो गई। कृपया फिर से कोशिश करें।',
  errOcrDownload: 'पढ़ने का टूल डाउनलोड नहीं हो पाया। एक बार इंटरनेट चालू करके फिर कोशिश करें।',
  warnDark: 'फोटो में अंधेरा है। अच्छी रोशनी में ली गई फोटो ठीक से पढ़ी जाती है।',
  warnBlurry: 'फोटो धुंधली लग रही है। फ़ोन को स्थिर रखकर दोबारा खींचें।',
  warnSmall: 'फोटो बहुत छोटी है। कागज़ के पास से फोटो खींचें।',
  tryAgain: 'फिर से कोशिश करें',

  pickPagesHint: (max) => `ज़्यादा से ज़्यादा ${max} पेज चुनें।`,
  pageLabel: (n) => `पेज ${n}`,
  readSelectedPages: (n) => `${n} पेज पढ़ो`,

  typeSure: (name) => `यह ${name} लग रहा है।`,
  typeMaybe: (name) => `यह शायद ${name} है, पर समझो पूरी तरह पक्का नहीं है।`,
  typeUnknown: 'यह कागज़ किस तरह का है, समझो पूरी तरह पक्का नहीं है।',
  docTypes: {
    income_certificate: { name: 'आय प्रमाण पत्र (इनकम सर्टिफिकेट)', about: 'इसमें सरकारी रिकॉर्ड के हिसाब से किसी व्यक्ति या परिवार की आमदनी लिखी होती है।' },
    caste_certificate: { name: 'जाति प्रमाण पत्र', about: 'इसमें लिखा होता है कि व्यक्ति किस जाति या वर्ग का है।' },
    domicile_certificate: { name: 'निवास प्रमाण पत्र', about: 'इसमें लिखा होता है कि व्यक्ति स्थायी रूप से कहाँ रहता है।' },
    birth_certificate: { name: 'जन्म प्रमाण पत्र', about: 'यह जन्म का सरकारी रिकॉर्ड है।' },
    death_certificate: { name: 'मृत्यु प्रमाण पत्र', about: 'यह मृत्यु का सरकारी रिकॉर्ड है।' },
    electricity_bill: { name: 'बिजली का बिल', about: 'इसमें बिजली की खपत और भरने वाली रकम लिखी होती है।' },
    water_bill: { name: 'पानी का बिल', about: 'इसमें पानी का भरने वाला पैसा लिखा होता है।' },
    ration_card: { name: 'राशन कार्ड या राशन की सूचना', about: 'यह सरकारी दुकान से राशन मिलने के बारे में है।' },
    aadhaar: { name: 'आधार से जुड़ा कागज़', about: 'यह आधार नंबर या आधार की जानकारी के बारे में है।' },
    pan_card: { name: 'पैन से जुड़ा कागज़', about: 'यह पैन (टैक्स पहचान) नंबर के बारे में है।' },
    bank_notice: { name: 'बैंक का पत्र', about: 'यह बैंक की ओर से आया पत्र या सूचना है।' },
    loan_notice: { name: 'कर्ज़ (लोन) की सूचना', about: 'यह किसी लोन या बकाया पैसे के बारे में है।' },
    income_tax_notice: { name: 'आयकर (इनकम टैक्स) की सूचना', about: 'यह आयकर विभाग की ओर से है।' },
    pension: { name: 'पेंशन से जुड़ा पत्र', about: 'यह पेंशन के बारे में है।' },
    court_notice: { name: 'कोर्ट या कानूनी नोटिस', about: 'यह अदालत की ओर से है या किसी कानूनी मामले के बारे में है। इसे गंभीरता से लें।' },
    land_record: { name: 'ज़मीन का रिकॉर्ड', about: 'यह ज़मीन के मालिकाना हक़ या ज़मीन की जानकारी के बारे में है।' },
    property_tax: { name: 'संपत्ति कर (हाउस टैक्स) का बिल', about: 'यह घर या संपत्ति के टैक्स के बारे में है।' },
    scholarship: { name: 'छात्रवृत्ति (स्कॉलरशिप) का पत्र', about: 'यह पढ़ाई के लिए मिलने वाली छात्रवृत्ति के बारे में है।' },
    farmer_scheme: { name: 'किसान योजना का पत्र', about: 'यह किसानों की किसी योजना या मदद के बारे में है।' },
    school_letter: { name: 'स्कूल का पत्र', about: 'यह स्कूल की ओर से है या पढ़ाई के बारे में है।' },
    marksheet: { name: 'अंकपत्र (मार्कशीट) या रिज़ल्ट', about: 'इसमें परीक्षा के नंबर या रिज़ल्ट लिखा है।' },
    insurance: { name: 'बीमा का कागज़', about: 'यह किसी बीमा पॉलिसी के बारे में है।' },
    traffic_challan: { name: 'ट्रैफ़िक चालान', about: 'यह ट्रैफ़िक या गाड़ी के नियम तोड़ने पर जुर्माना है।' },
    job_notice: { name: 'नौकरी या परीक्षा की सूचना', about: 'यह सरकारी नौकरी, भर्ती या उसकी परीक्षा के बारे में है।' },
    application_receipt: { name: 'आवेदन की रसीद', about: 'इससे पता चलता है कि आवेदन जमा हो गया है।' },
    application_decision: { name: 'आवेदन के बारे में पत्र', about: 'इसमें किसी आवेदन का फ़ैसला या जानकारी दी गई है।' },
    government_notice: { name: 'सरकारी सूचना', about: 'यह किसी सरकारी दफ़्तर की सूचना या आदेश है।' },
    lab_report: { name: 'एक मेडिकल जाँच रिपोर्ट', about: 'इसमें खून या दूसरी मेडिकल जाँचों के नतीजे हैं।' },
    rental_agreement: { name: 'किराया समझौता (रेंट एग्रीमेंट)', about: 'यह मकान मालिक और किरायेदार के बीच का समझौता है।' },
    loan_agreement: { name: 'लोन का समझौता', about: 'इसमें लोन की शर्तें हैं: ब्याज, EMI और शुल्क।' },
    contract: { name: 'एक समझौता (एग्रीमेंट)', about: 'यह एक समझौता है, जिसकी शर्तें दोनों पक्षों को माननी होती हैं।' },
    unknown: { name: 'कागज़', about: '' }
  },

  seedhiBaat: 'सीधी बात',
  docSays: 'कागज़ में लिखा है',
  samjhoSays: 'समझो का मतलब',
  unclearText: 'यह हिस्सा साफ़ नहीं पढ़ा गया — कृपया असली कागज़ देखें।',

  aboutPerson: (name) => `यह कागज़ ${name} के बारे में है।`,
  issuedBy: (authority) => `यह यहाँ से आया है: ${authority}।`,
  status: {
    approved: 'आवेदन मंज़ूर हो गया है।',
    rejected: 'आवेदन नामंज़ूर (रिजेक्ट) कर दिया गया है।',
    pending: 'आवेदन अभी प्रक्रिया में है। अभी फ़ैसला नहीं हुआ है।',
    cancelled: 'इसे रद्द कर दिया गया है।'
  },
  dateSentence: {
    deadline: (d) => `आख़िरी तारीख़: ${d}।`,
    due: (d) => `पैसे भरने की आख़िरी तारीख़: ${d}।`,
    hearing: (d) => `कागज़ में हाज़िर होने की यह तारीख़ लिखी है: ${d}।`,
    issue: (d) => `यह कागज़ ${d} को जारी हुआ।`,
    validity: (d) => `यह ${d} तक मान्य है।`,
    birth: (d) => `जन्म तिथि लिखी है: ${d}।`,
    other: (d) => `एक तारीख़ लिखी है: ${d}।`
  },
  daysLeft: (days) => `${days} दिन बाकी हैं।`,
  dueToday: 'यह तारीख़ आज ही है।',
  datePassed: 'ध्यान दें: यह तारीख़ निकल चुकी है।',
  amountSentence: {
    payable: (a) => `भरने वाली रकम: ${a}।`,
    income: (a) => `लिखी गई आय: ${a}।`,
    fine: (a) => `जुर्माना या देरी का शुल्क लिखा है: ${a}।`,
    fee: (a) => `फ़ीस लिखी है: ${a}।`,
    sanctioned: (a) => `मंज़ूर या भेजी गई रकम: ${a}।`,
    other: (a) => `एक रकम लिखी है: ${a}।`
  },
  actionsPointer: 'कागज़ में आपसे कुछ करने को कहा गया है। नीचे "आपको क्या करना है" देखें।',
  noActionFound: 'कागज़ में आपसे कुछ करने की बात साफ़ नहीं लिखी है।',
  keepSafe: 'इस कागज़ को संभालकर रखें।',
  doBefore: (d) => `यह काम ${d} से पहले करें।`,
  bringDocs: (list) => `ये कागज़ तैयार रखें: ${list}।`,
  contactFor: (c) => `सवाल हो तो यहाँ संपर्क करें: ${c}।`,
  warningPointer: 'कागज़ में एक चेतावनी लिखी है। उसे ध्यान से पढ़ें।',
  rejectedNext: 'अगर आपको लगता है कि गलती हुई है, तो जिस दफ़्तर से यह पत्र आया है, वहाँ पूछें।',
  lowQuality: 'फोटो बहुत साफ़ नहीं थी, इसलिए कुछ बातें गलत पढ़ी गई हो सकती हैं। असली कागज़ से मिला लें।',

  cardTodo: 'आपको क्या करना है',
  cardDates: 'ज़रूरी तारीख़',
  cardAmount: 'रकम',
  cardWhere: 'कहाँ जाना है',
  cardWarnings: 'ध्यान रखें',
  cardDocs: 'कौन से कागज़ चाहिए',
  cardPerson: 'किसके बारे में',
  cardFrom: 'किसने भेजा',
  cardNumbers: 'ज़रूरी नंबर',
  cardContact: 'संपर्क',
  refKinds: {
    application: 'आवेदन नंबर',
    certificate: 'प्रमाण पत्र नंबर',
    consumer: 'उपभोक्ता नंबर',
    account: 'खाता नंबर',
    case: 'केस नंबर',
    reference: 'पत्र नंबर',
    registration: 'पंजीकरण नंबर',
    receipt: 'रसीद नंबर',
    other: 'नंबर'
  },
  requiredDocNames: {
    aadhaar: 'आधार कार्ड',
    pan: 'पैन कार्ड',
    ration_card: 'राशन कार्ड',
    voter_id: 'वोटर आईडी',
    passbook: 'बैंक पासबुक',
    photo: 'फोटो',
    income_certificate: 'आय प्रमाण पत्र',
    caste_certificate: 'जाति प्रमाण पत्र',
    domicile_certificate: 'निवास प्रमाण पत्र',
    birth_certificate: 'जन्म प्रमाण पत्र',
    land_record: 'ज़मीन का रिकॉर्ड',
    electricity_bill: 'बिजली का बिल',
    address_proof: 'पते का प्रमाण',
    id_proof: 'पहचान पत्र',
    affidavit: 'शपथ पत्र (एफ़िडेविट)',
    application_form: 'आवेदन फ़ॉर्म'
  },

  voiceDownloadNote: 'पहली बार आवाज़ डाउनलोड हो रही है (लगभग 58 MB)। उसके बाद बिना इंटरनेट भी चलेगी।',

  listen: 'सुनाओ',
  pause: 'रुको',
  resume: 'आगे सुनाओ',
  stop: 'बंद करो',
  noVoice: 'इस फ़ोन में हिंदी की आवाज़ नहीं है।',
  noVoiceHint: 'फ़ोन की सेटिंग (Text-to-speech) में आवाज़ जोड़ सकते हैं, या किसी और भाषा में सुनें।',
  listenInHindi: 'हिंदी में सुनाओ',
  listenInEnglish: 'अंग्रेज़ी में सुनाओ',
  noSpeechSupport: 'यह ब्राउज़र बोलकर नहीं सुना सकता।',

  disclaimer: 'समझो आपके कागज़ को आसान बनाता है। ज़रूरी बातें हमेशा असली कागज़ या जारी करने वाले दफ़्तर से मिला लें। समझो सरकारी सेवा नहीं है और यह कानूनी सलाह नहीं है।',
  fullText: 'समझो ने क्या पढ़ा',
  fullTextHint: 'रंगी हुई लाइनें साफ़ नहीं पढ़ी जा सकीं।',
  newDocument: 'नया कागज़',
  save: 'इस फ़ोन में सेव करें',
  saved: 'इस फ़ोन में सेव हो गया',
  share: 'शेयर करें',
  copied: 'कॉपी हो गया',
  translateLines: 'कागज़ की अंग्रेज़ी लाइनें हिंदी में देखें',
  helperMode: 'हेल्पर मोड',
  helperModeHint: 'दूसरों के कागज़ पढ़ने वालों के लिए (CSC, NGO, वॉलंटियर)। इसमें सेव बंद रहता है, और "अगला व्यक्ति" दबाने से सब मिट जाता है।',
  nextPerson: 'अगला व्यक्ति',
  listenMode: 'सुनाओ मोड',
  listenModeHint: 'समझाना तैयार होते ही समझो उसे अपने-आप पढ़कर सुनाता है।',
  settingsTitle: 'सेटिंग',
  shareVoiceNote: 'वॉइस नोट भेजें',
  makingVoiceNote: 'वॉइस नोट बन रहा है…',
  voiceNoteFailed: 'इस फ़ोन पर वॉइस नोट नहीं बन पाया।',
  translateOtherLines: 'कागज़ की दूसरी भाषा की लाइनें हिंदी में देखें',
  translateAiNote: 'जो लाइनें अंग्रेज़ी में नहीं हैं, उनका अनुवाद एक AI सेवा (Groq) करती है।',
  translateConsent: 'अनुवाद के लिए ये लाइनें इंटरनेट से समझो के सर्वर पर भेजी जाएँगी। वहाँ सेव नहीं होतीं। आधार और फ़ोन जैसे नंबर पहले हटा दिए जाते हैं।',
  translateConfirm: 'हाँ, अनुवाद करें',
  translating: 'अनुवाद हो रहा है…',
  translateNote: 'मशीन से अनुवाद — गलती हो सकती है।',
  translateFailed: 'अभी अनुवाद नहीं हो पाया।',
  retryRotated: 'फोटो घुमाकर फिर से पढ़ो',

  addToCalendar: 'कैलेंडर में याद दिलाना जोड़ें',
  askTitle: 'इस कागज़ के बारे में पूछें',
  askHint: 'अपने शब्दों में पूछें। समझो आपके कागज़ से जवाब देगा — और अगर वहाँ नहीं है, तो सिर्फ़ सरकारी वेबसाइटों से।',
  askPlaceholder: 'अपना सवाल लिखें या बोलें…',
  askSend: 'पूछें',
  askMic: 'बोलकर पूछें',
  askListening: 'सुन रहा है… अब बोलें',
  askWebToggle: 'ज़रूरत हो तो सरकारी वेबसाइटें भी देखें',
  askConsent: 'जवाब देने के लिए इस कागज़ में लिखी बातें और आपका सवाल इंटरनेट से समझो के सर्वर और एक AI सेवा (Groq) पर भेजे जाएँगे। आधार, पैन, फ़ोन नंबर और ईमेल पहले हटा दिए जाते हैं। कुछ भी सेव नहीं होता।',
  askOfficialOnly: 'सिर्फ़ सरकारी वेबसाइटें देखी जाती हैं, जैसे:',
  askConsentConfirm: 'ठीक है, पूछें',
  askThinkingDoc: 'आपका कागज़ पढ़ रहे हैं',
  askThinkingWeb: 'सरकारी वेबसाइटें देख रहे हैं',
  askFromDoc: 'आपके कागज़ से',
  askFromWeb: 'सरकारी वेबसाइट से',
  askNotFound: 'समझो को यह बात न आपके कागज़ में मिली, न सरकारी वेबसाइटों पर। कृपया उस दफ़्तर से पूछें जिसने यह कागज़ भेजा है।',
  askUnverified: 'समझो इसे कागज़ की किसी पक्की लाइन से नहीं मिला पाया। कृपया कागज़ देखकर जाँच लें।',
  askSources: 'स्रोत',
  askOfficial: 'सरकारी',
  askFailed: 'अभी जवाब नहीं मिल पाया। कृपया फिर से कोशिश करें।',
  askBusy: 'अभी बहुत सारे सवाल आ रहे हैं। एक मिनट रुककर फिर पूछें।',
  askAiNote: 'ये जवाब AI ने लिखे हैं, इनमें गलती हो सकती है। ज़रूरी बातें दफ़्तर से पक्की कर लें।',
  askTryNext: 'आप यह भी पूछ सकते हैं:',
  askJump: 'सवाल पूछें',
  askSuggest: {
    fillForm: 'यह फ़ॉर्म कैसे भरूँ? हर खाना समझाइए।',
    first: 'पहले मुझे क्या करना चाहिए?',
    deadline: 'आख़िरी तारीख़ निकल गई तो क्या होगा?',
    pay: 'इसे कैसे और कहाँ जमा करें?',
    papers: 'ये कागज़ कहाँ से बनवाएँ?',
    rejected: 'यह क्यों रद्द हुआ, और अब मैं क्या कर सकता हूँ?',
    meaning: 'इस कागज़ को बहुत आसान शब्दों में समझाओ।',
    contact: 'इसके बारे में किससे बात करूँ?',
    schemes: 'इस कागज़ के हिसाब से मैं किन सरकारी योजनाओं के लिए योग्य हो सकता हूँ?'
  },

  helpTitle: 'मदद पाएँ',
  nearbyTitle: 'सबसे पास का दफ़्तर',
  nearbyNote: 'आपके पास का नक्शा खुलेगा। आपकी लोकेशन सिर्फ़ नक्शे को जाती है — समझो उसे न देखता है, न सेव करता है।',
  locating: 'आपकी लोकेशन ढूँढ रहे हैं…',
  schemesTitle: 'सरकारी योजनाएँ',
  schemesText: 'समझो सरकारी योजना वेबसाइटों पर देख सकता है कि इस कागज़ के हिसाब से कौन-सी योजनाएँ आपके काम की हो सकती हैं।',
  schemesButton: 'मेरे लिए योजनाएँ ढूँढें',
  legalTitle: 'मुफ़्त कानूनी मदद',
  legalText: 'आपको विधिक सेवा प्राधिकरण से मुफ़्त वकील मिल सकता है — जैसे महिलाएँ, बच्चे, SC/ST, मज़दूर, दिव्यांग और कम आमदनी वाले लोग।',
  legalCall: (n) => `${n} पर कॉल करें (मुफ़्त)`,
  legalNearby: 'सबसे पास का विधिक सेवा प्राधिकरण',
  legalMore: 'और कानूनी मदद',
  legalAskConsent: 'आपका सवाल इंटरनेट से समझो के सर्वर और एक AI सेवा (Groq) पर भेजा जाएगा, जो जवाब सिर्फ़ सरकारी वेबसाइटों पर ढूँढते हैं। आधार, पैन, फ़ोन नंबर और ईमेल पहले हटा दिए जाते हैं। कुछ भी सेव नहीं होता।',
  navLegal: 'कानूनी मदद'
}
